/*
 * Collapsible class
 * <div class="js-collapsible" data-target="#my-container">Collapse</div>
 * <div class="collapsible-container"><div class="collapsible-content">Content goes here</div></div>
 */
class Collapsible {
  /**
   * @private
   * @property {HTMLElement} #element - HTMLElement of the collapsible handle
   */

  #element

  /**
   * @private
   * @property {HTMLElement} #collapsibleContent - HTMLElement of the collapsible content to be opened/closed
   */
  #collapsibleContent

  /**
  * @constructor
  * @param {HTMLElement} element element to bind to
  */
  constructor(element) {
    this.#element = element;
    this.#collapsibleContent = document.querySelector(this.#element.dataset.target);

    if (this.#collapsibleContent) {
      this.#element.addEventListener('click', this.#onCollapseHandleClicked.bind(this) );
    }
  }

  /**
   * Collapse handle click event
   * @param {MouseEvent} event - Event
   */
  #onCollapseHandleClicked(event) {
    event.preventDefault();

    this.#collapsibleContent.classList.toggle('collapsible-show');

    if (this.#collapsibleContent.classList.contains('collapsible-show')) {
      this.#element.classList.add('collapsible-content-open');
    } else {
      this.#element.classList.remove('collapsible-content-open');
    }
  }

  /**
   * Called to initialize collapse areas and handles
   */
  static init() {
    document.querySelectorAll('.js-collapsible[data-target]').forEach(element => new Collapsible(element));
  }
}

export default Collapsible;
